import React, { useState } from "react";
import { Drawer, Form, Input, Button, message } from "antd";
import API from "../../api"; // Import your API instance

const ChangePasswordDrawer = ({ open, setOpen }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);

  const userData = JSON.parse(localStorage.getItem("userData"));
  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        ...values,
        userId: userData?.id, // Add userData.id here
      };
      // await API.post(`/change-password`, values);
      await API.put(`/users/change-password/${userData?.id}`, payload);
      message.success("Password changed successfully!");
      setOpen(false);
      form.resetFields(); // Clear form fields after submission
    } catch (err) {
      console.error(err);
      message.error(
        err.response?.data?.message || "Failed to change password!"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title="Change Password"
      width={450}
      placement="right"
      onClose={() => setOpen(false)}
      open={open}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="Current Password"
          name="currentPassword"
          rules={[
            { required: true, message: "Please enter your current password!" },
          ]}
        >
          <Input.Password placeholder="Enter current password" />
        </Form.Item>
        <Form.Item
          label="New Password"
          name="newPassword"
          rules={[
            { required: true, message: "Please enter a new password!" },
            { min: 6, message: "Password must be at least 6 characters long!" },
          ]}
        >
          <Input.Password placeholder="Enter new password" />
        </Form.Item>
        <Form.Item
          label="Confirm New Password"
          name="confirmPassword"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "Please confirm your new password!" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise?.resolve();
                }
                return Promise?.reject(new Error("Passwords do not match!"));
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm new password" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading} block>
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default ChangePasswordDrawer;
